import PageBanner from "../../../../src/components/PageBannerContactUs";
import ContactThankYouBody from "../../../../src/components/contact/contactThankYouBody";
import DefaultNoHead from "../../../../src/gatsby-theme-carbon/templates/DefaultNoHead";
import * as React from 'react';
export default {
  PageBanner,
  ContactThankYouBody,
  DefaultNoHead,
  React
};